import ApiService from '../../../shared/services/ApiService';

export default{
    getActivity(){
        return ApiService.get('/activity');
    },

    getMemberActivity(uid){
        return ApiService.get(`/team-activities/${uid}`);
    },

    manualClockIn(data){
       return ApiService.post('/manual-clock-in', data)
    },

    manualClockOut(data){
        return ApiService.post('/manual-clock-out', data)
    }

}